import React from 'react';
import withAbacus from '../with-abacus/with-abacus';

export function AbacusClasses({abacus = {}, children, testNames = []}) {
    let classNames = testNames.reduce((className, testName) => {
        let test = abacus[testName] || {value: 0};
        return `${className} ${testName}-${test.value}`;
    }, '');

    if (classNames === '') {
        return children;
    }

    return React.Children.map(children, (child) => {
        let className = child.props.className || '';
        className = (className.length ? `${className} ${classNames}` : classNames);
        return React.cloneElement(child, {className});
    });
}

export default withAbacus(AbacusClasses);


// WEBPACK FOOTER //
// ./src/universal/abacus/abacus-classes/abacus-classes.js